import request from '../request'

export const recentNewsApi = {
  listRecentNews (params) {
    return request.get('/recentNews', { params: params })
  },
  saveRecentNews (data) {
    return request.post('/recentNews', data)
  },
  deleteRecentNews (id) {
    return request.delete('/recentNews/' + id)
  },
  getRecentNews (id) {
    return request.get('/recentNews/' + id)
  },
  updateRecentNews (id, data) {
    return request.put('/recentNews/' + id, data)
  },
}

export default recentNewsApi
